import React from 'react';
import { useGameLoopContext, useGameStateContext } from '../../app/GameProviders';
import { CONSTANTS } from '../../data.js';

export function InstructionsBanner() {
  const { gameState } = useGameStateContext();
  const { currentDay, currentWeek } = useGameLoopContext();

  // Default: show the banner
  let shouldShow = true;

  // In Career mode ("playing"), optionally restrict to first day only
  if (gameState === 'playing' && CONSTANTS.UI && CONSTANTS.UI.SHOW_INSTRUCTIONS_FIRST_DAY_ONLY) {
    shouldShow = currentWeek === 1 && currentDay === 1;
  }

  if (!shouldShow) return null;

  return (
    <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-30">
      <p className="text-center text-sm text-slate-400 bg-slate-800/50 backdrop-blur rounded-lg px-4 py-2">
        Drag ingredients to combine. Drag off-board to remove. Use scroll wheel to zoom.
      </p>
    </div>
  );
}
